export default __webpack_public_path__ + "static/media/wheel_2.da379959.svg";